import { render, staticRenderFns } from "./Kontokorrent.vue?vue&type=template&id=431307bb&"
import script from "./Kontokorrent.vue?vue&type=script&lang=js&"
export * from "./Kontokorrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports